import styled from 'styled-components';

export const PageHeaderRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;
